import React from "react";
import AuthService from "../services/AuthService";
import Login from "./Login";
import logo from "../assets/wmedic-logo.png";

export default function Home({ setCurrentUser }) {
  const currentUser = AuthService.getCurrentUser();

  if (!currentUser) {
    return (
      <div
        style={{
          backgroundImage: `url(${logo})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "calc(100vh - 70px)",
        }}
        className="container mt-4 text-center"
      >
        <h2>Dobrodošli u DoctorVisit</h2>
        <p>Molimo vas da se prijavite da biste nastavili.</p>
        <Login setCurrentUser={setCurrentUser} />
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundImage: `url(${logo})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",

        minHeight: "calc(100vh - 70px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "40px",
          borderRadius: "15px",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
          Dobrodošli u kartoteku  <br />
        </h1>
        <p style={{ fontSize: "1.2rem", marginTop: "10px" }}>
          Upravljajte lekarima, pacijentima i posetama
        </p>
      </div>
    </div>
  );
}
